<template>
	<div class="db2-viewport" role="group" aria-label="Preview screen size">
		<button
			v-for="v in viewports"
			:key="v.id"
			type="button"
			class="db2-viewport-btn"
			:class="{ on: value === v.id }"
			:title="v.label"
			@click="$emit('input', v.id)"
		>
			<v-icon small>{{ v.icon }}</v-icon>
			<span>{{ v.label }}</span>
		</button>
	</div>
</template>

<script>
import { VIEWPORTS } from './dashboardModel';

/**
 * Toggle Live / Desktop / Tablet / Mobile canvas preview.
 */
export default {
	name: 'ViewportToggle',
	props: {
		/** auto | desktop | tablet | mobile */
		value: {
			type: String,
			default: 'auto'
		}
	},
	data() {
		return { viewports: VIEWPORTS };
	}
};
</script>
